import { BookingSlot } from '../../api-types/models/Booking';
import {
    addDays,
    addHours,
    addMinutes,
    areIntervalsOverlapping
} from 'date-fns';

export function findSlotsForTimeFrame(
    startOfWeekDate: Date,
    day: number,
    hour: number,
    slotsPerWeek: BookingSlot[]
) {
    const date = addDays(startOfWeekDate, day).setHours(hour);
    const slots: BookingSlot[] = [];
    slotsPerWeek.forEach((slot) => {
        const intervalLeft = {
            start: new Date(slot.from),
            end: addMinutes(slot.from, slot.duration)
        };
        const intervalRight = { start: new Date(date), end: addHours(date, 1) };

        if (
            areIntervalsOverlapping(intervalLeft, intervalRight) &&
            !slots.includes(slot)
        ) {
            slots.push(slot);
        }
    });

    return slots;
}

// Check if this is the starting hour for the slot (where it should be rendered)
export function isSlotStartingHour(
    startOfWeekDate: Date,
    day: number,
    hour: number,
    slot: BookingSlot
): boolean {
    const slotStartDate = new Date(slot.from);
    const cellDate = addDays(startOfWeekDate, day);

    // Check if it's the same day and the slot starts in this hour
    return (
        slotStartDate.getDate() === cellDate.getDate() &&
        slotStartDate.getMonth() === cellDate.getMonth() &&
        slotStartDate.getFullYear() === cellDate.getFullYear() &&
        slotStartDate.getHours() === hour
    );
}
